export function swipersInit() {

  const swiperBanners = new Swiper('.swiper-banners', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    pagination: {
      el: '.swiper-pagination.banners',
      clickable: true,
    },
  });

  const swiperPhones = new Swiper('.swiper-phones', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    speed: 700,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.swiper-button-next.phones',
      prevEl: '.swiper-button-prev.phones'
    },
  });

  const swiperNewModels = new Swiper('.swiper-new-model', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '.swiper-button-next.new-model',
      prevEl: '.swiper-button-prev.new-model',
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        loop: true,
        //centerInsufficientSlides: true,//
        centeredSlides: true,
        centeredSlidesBounds: false,
        slidesPerView: 3,
        spaceBetween: 150,

      },
    },
    pagination: {
      el: '.swiper-pagination.new-model',
      dynamicBullets: true,
      clickable: true,
    }
  });

  const swipersDropdownNewModels = document.querySelectorAll('.drop-model');

  swipersDropdownNewModels.forEach((drop) => {
    let category = drop.getAttribute('data-ref');

    new Swiper(drop, {
      observer: true,
      observeParents: true,
      observeSlideChildren: true,
      watchOverflow: true,
      slidesPerView: 3,
      spaceBetween: 30,
      navigation: {
        nextEl: `.drop-next-${category}`,
        prevEl: `.drop-prev-${category}`,
      },
      pagination: {
        el: '.swiper-pagination',
        dynamicBullets: true,
        clickable: true,
      }
    });
  });

  const swiperNewModelVerson = new Swiper('.swiper-new-model-version', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.version',
      prevEl: '.swiper-button-prev.version',
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

  const swiperLocations = new Swiper('.swiper-locations', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.locations',
      prevEl: '.swiper-button-prev.locations',
    },
    pagination: {
      el: '.swiper-pagination.locations',
      clickable: true,
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 30,
      }
    },
  });

  const swiperPromotion = new Swiper('.swiper-promotion', {
    slidesPerView: 1,
    watchOverflow: true,
    observer: true,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '.swiper-button-next.promotion',
      prevEl: '.swiper-button-prev.promotion',
    },
    pagination: {
      el: '.swiper-pagination.promotion',
      clickable: true,
    },
    breakpoints: {
      900: {
        slidesPerView: 2,
        spaceBetween: 30,
      },

      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

  const swiperCategories = new Swiper('.swiper-categories', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 3,
    centeredSlides: true,
    navigation: {
      nextEl: '.swiper-button-next.categories',
      prevEl: '.swiper-button-prev.categories',
    },
    breakpoints: {
      992: {
        slidesPerView: 6,
        spaceBetween: 5,
        centeredSlides: false,
      },
    },
  });

  const swiperAwards = new Swiper('.swiper-awards', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.awards',
      prevEl: '.swiper-button-prev.awards',
    },
    pagination: {
      el: '.swiper-pagination.awards',
      clickable: true,
    },
  });

  const swiperHighlightsTabs = new Swiper('.swiper-highlights-tabs', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 2,
    navigation: {
      nextEl: '.swiper-button-next.highlights-tabs',
      prevEl: '.swiper-button-prev.highlights-tabs',
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
    },
  });

  const swiperConsortiumTabs = new Swiper('.swiper-consortium-tabs', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 3,
    navigation: {
      nextEl: '.swiper-button-next.consortium',
      prevEl: '.swiper-button-prev.consortium',
    },
    breakpoints: {
      992: {
        slidesPerView: 5,
      },
    },
  });

  const swiperHondaEvolution = new Swiper('.swiper-honda-evolution', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 4,
    navigation: {
      nextEl: '.swiper-button-next.honda-evolution',
      prevEl: '.swiper-button-prev.honda-evolution',
    },
    breakpoints: {
      1200: {
        slidesPerView: 7,
      },
    },
  });

  const swiperHondaEvolutionMobile = new Swiper('.swiper-honda-evolution-mobile', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.honda-evolution-mobile',
      prevEl: '.swiper-button-prev.honda-evolution-mobile',
    },
  });

  const swiperAcessoriesCars = new Swiper('.swiper-acessories-cars', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 2,
    navigation: {
      nextEl: '.swiper-button-next.acessories-cars',
      prevEl: '.swiper-button-prev.acessories-cars',
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      1200: {
        slidesPerView: 7,
      },
    },
  });

  const swiperAcessoriesCarsMobile = new Swiper('.swiper-acessories-cars-mobile', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.acessories-cars-mobile',
      prevEl: '.swiper-button-prev.acessories-cars-mobile',
    },
  });

  const swiperUsed = new Swiper('.used-cars-internal-slider-content', {
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.used',
      prevEl: '.swiper-button-prev.used',
    },
    clickable: true,
    thumbs: {
      swiper: swiperUsedThumbs,
    },
  });

  const swiperUsedModelInternalStamp = new Swiper('.used-cars-internal-stamps-slider', {
    clickable: true,
    slidesPerView: 3,
    watchOverflow: true,
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    pagination: {
      el: '.swiper-pagination.stamp',
      clickable: true
    },
  });

  const swiperUsedThumbs = new Swiper('.used-cars-internal-slider-thumbs', {
    slidesPerView: 3,
    freeMode: true,
    spaceBetween: 60,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    navigation: {
      nextEl: '.swiper-button-next.used-thumbs',
      prevEl: '.swiper-button-prev.used-thumbs',
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
        spaceBetween: 0,
      }
    }
  });

  const swiperUsedRelated = new Swiper('.swiper-used-related', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '.swiper-button-next.used-related',
      prevEl: '.swiper-button-prev.used-related',
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
    pagination: {
      el: '.swiper-pagination.used-related',
      dynamicBullets: true,
      clickable: true,
    }
  });

  const swiperHighlights = new Swiper('.swiper-highlights', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    navigation: {
      nextEl: '.swiper-button-next.highlights-next',
      prevEl: '.swiper-button-prev.highlights-prev',
    },
    pagination: {
      el: '.swiper-pagination.highlights',
      clickable: true,
      type: "progressbar",
    },
  });

  const swiperLastSeen = new Swiper('.swiper-used-lastseen', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '.swiper-button-next.used-lastseen',
      prevEl: '.swiper-button-prev.used-lastseen',
    },
    breakpoints: {
      992: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
    pagination: {
      el: '.swiper-pagination.used-lastseen',
      dynamicBullets: true,
      clickable: true,
    }
  });

  const swiperVantagens = new Swiper('.swiper-vantagens', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    centerInsufficientSlides: true,
    pagination: {
      el: '.swiper-pagination.vantagens',
      dynamicBullets: true,
      clickable: true,
    }
  });

  const swiperNewFamilies = new Swiper('.swiper-new-family-cars', {
    observer: true,
    observeParents: true,
    observeSlideChildren: true,
    watchOverflow: true,
    slidesPerView: 1,
    centerInsufficientSlides: true,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next.new-family-cars',
      prevEl: '.swiper-button-prev.new-family-cars',
    },
    pagination: {
      el: '.swiper-pagination.new-family-cars',
      dynamicBullets: true,
      clickable: true,
    }
  });

}




